<template>
    <SettingsSection :section="section" :index="index" :level="level" :isLoading="isLoading" :initiated="initiated">
        <template v-slot:settingList>

            <h3 class="mt-3">Customer notification emails</h3>
            <v-list-item v-for="ct in customerTemplates" :key="ct.key" dense class="px-0"
                :to="{ name: 'EditEmailSetting', params: { emailTemplate: ct.key } }">
                <v-list-item-content>
                    <h5 v-text="ct.title" style="opacity: 0.9;" />
                    <p v-text="ct.description" class="ma-0 mt-1 mr-2" style="opacity: 0.8; white-space: pre-line;" />
                </v-list-item-content>
                <v-list-item-action class="mr-0">
                    <span :class="ct.enabled ? 'primary--text' : ''" :style="ct.enabled ? '' : 'opacity: 0.6;'">
                        {{ ct.enabled ? 'Enabled' : 'Disabled' }}
                    </span>
                </v-list-item-action>
                <v-list-item-action>
                    <v-btn icon small>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>

            <h3 class="mt-3">Other emails</h3>
            <v-list-item v-for="at in agentTemplates" :key="at.key" dense class="px-0"
                :to="{ name: 'EditEmailSetting', params: { emailTemplate: at.key } }">
                <v-list-item-content>
                    <h5 v-text="at.title" style="opacity: 0.9;" />
                    <p v-text="at.description" class="ma-0 mt-1 mr-2" style="opacity: 0.8; white-space: pre-line;" />
                </v-list-item-content>
                <v-list-item-action class="mr-0">
                    <span :class="at.enabled ? 'primary--text' : ''" :style="at.enabled ? '' : 'opacity: 0.6;'">
                        {{ at.enabled ? 'Enabled' : 'Disabled' }}
                    </span>
                </v-list-item-action>
                <v-list-item-action>
                    <v-btn icon small>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>

        </template>
    </SettingsSection>
</template>


<script>
//import SettingsConstants from '@/helpers/Constants/SettingsConstants';
import Section from "./Section.js"
//import SettingRow from "./SettingRow.vue";
const SettingsSection = () => import("./SettingsSection.vue");
import EmailTemplatesMixin from '@/views/admin/settings/email/EmailTemplatesMixin.js';

export default {
    name: "EmailSection",
    props: {
        section: Section,
        index: Number,
        level: Number,
        isLoading: Boolean,
        initiated: Boolean,
    },
    components: {
        SettingsSection,
        //SettingRow,
    },
    mixins: [EmailTemplatesMixin],

    data() {
        return {
            // templateRows is provided by mixin
        };
    },

    mounted() {
        this.fetchTemplates();
    },

    methods: {},

    computed: {
        // resolvedRows, agentTemplates, customerTemplates come from mixin
    },

    watch: {},
};
</script>


<style lang="scss" scoped></style>